import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Facebook } from 'components/icons';

const FacebookShare = ({ appId, product, className }, { testId }) => {
  const facebookLink = 'https://www.facebook.com/dialog/feed?' + queryString.stringify({
    app_id: appId,
    link: product.link,
    name: product.name,
    caption: product.style,
    description: product.name,
    picture: product.image
  });

  return (
    <a
      href={facebookLink}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Share on Facebook"
      data-te="TE_PDP_SHAREFACEBOOK"
      data-test-id={testId('facebookShareIcon')}>
      <Facebook size={22}/>
    </a>
  );
};

FacebookShare.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default FacebookShare;
